import Theme from '@adsk/alloy-react-theme';
import styled from 'styled-components';

export const accordionItemContentStyle = {
  ...Theme.typography.bodySmall,
  paddingLeft: '28px',
};

export const StyledAccordion = styled.div`
  .ProjectMemberProfile_AccordionItem .ProjectMemberProfile_AccordionItem {
    background-color: transparent;
    font-weight: ${Theme.typography.labelMedium.fontWeight};
    font-size: ${Theme.typography.labelMedium.fontSize};
    line-height: ${Theme.typography.labelMedium.lineHeight};
    width: 100%;
    min-height: 20px;
    padding: 0;
  }
  & > div:last-child {
    margin-bottom: 0;
  }
`;

export const accordionItemContainerStyle = {
  position: 'relative',
  marginLeft: '-12px',
  marginBottom: '12px',
};

export const toggleContainerStyle = {
  position: 'absolute',
  top: '4px',
  right: '0',
  display: 'flex',
  zIndex: '1',
};

export const toggleLabelStyle = {
  ...Theme.typography.caption,
  margin: '3px 0 0 5px',
};

export const noAccordionProductStyle = {
  flex: 'auto',
  margin: '0 16px 0 28px',
  minHeight: '28px',
  lineHeight: '20px',
  display: 'flex',
  alignItems: 'center',
  color: Theme.colors.charcoal500,
};

export const subscriptionNotificationStyle = {
  boxShadow: 'none',
  padding: '0px 10px',
};
